import { styled } from '@fluentui/react';
import { ListPickerBase } from './ListPicker.base';
import { getStyles } from './ListPicker.styles';
import { IListPickerProps, IListPickerStyleProps, IListPickerStyles } from './ListPicker.types';

// Use Fabric Base guidelines since this might be contributed back to Fabric.
export const ListPicker = styled<IListPickerProps, IListPickerStyleProps, IListPickerStyles>(ListPickerBase, getStyles, undefined, {
  scope: 'ListPicker',
});
